import React, { useState, useEffect } from 'react';
import { useRouterHooks } from '@utils/routerHooks';
import Spinner from '@components/Spinner';
import ObjectiveService from '@services/objectiveService';

interface TParams {
  objectiveId?: number;
}

export default function withObjective(WrappedComponent: any) {
  return () => {
    const { match } = useRouterHooks<TParams>();
    const [loading, setLoading] = useState(false);
    const [objective, setObjective] = useState<Objective>();

    const id = match.params.objectiveId || 0;

    useEffect(() => {
      if (!id) {
        return;
      }

      if (
        !loading &&
        (!objective || (objective && objective.id !== Number(match.params.objectiveId)))
      ) {
        setLoading(true);
        ObjectiveService.getOne(id).then((o: any) => {
          setObjective(o);
          setLoading(false);
        });
      }
    }, [objective, id, loading, match.params.objectiveId]);

    if (!id) {
      return <Spinner />;
    }

    if (loading) {
      return <Spinner />;
    }

    if (!objective) {
      return null;
    }

    return <WrappedComponent objective={objective} />;
  };
}
